import { Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-cancel-swap-error-dialog',
  imports: [TranslatePipe,MatDialogModule],
  templateUrl: './cancel-swap-error-dialog.html',
  styleUrl: './cancel-swap-error-dialog.scss',
})
export class CancelSwapErrorDialog {
  constructor() { }

  ngOnInit() {
  }
}
